import axios from 'axios';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  APP_ACTION_GET_PADDING_NO_CONTENT,
  APP_ACTION_GET_PADDING_FAILED,
  logNewRelicError
} from '../utils/newRelicActions';

function fetchHDMSAPIinfo(payload) {
  const baseUrl = window?.__EXPERIENCE_PROPS__?.expConfiguration?.['flooring-base-url'];
  const path = 'api/hdms/getCarpetPadding';
  const hdmsURI = `${baseUrl}/${path}`;
  return axios.post(hdmsURI, payload)
    .then((resp) => {
      if (isEmpty(resp.data)) {
        logNewRelicError(
          APP_ACTION_GET_PADDING_NO_CONTENT,
          path,
          get(resp, 'status'),
          hdmsURI,
          payload
        );
      }
      return resp.data;
    })
    .catch((error) => {
      logNewRelicError(
        APP_ACTION_GET_PADDING_FAILED,
        path,
        get(error, 'status', 500),
        hdmsURI,
        payload
      );
      throw new Error(`API ERROR in ${hdmsURI} ===>`, error);
    });
}

export default fetchHDMSAPIinfo;